import { useEffect, useState } from 'react';

import { getPreSettlements, deletePreSettlement, patchPreSettlement } from '../../api';
import authentication from '../../api/auth/authentication';

export const usePresettlements = (location) => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);
  const [requestId, updateRequestId] = useState();
  const [userPartyCode, setUserPartyCode] = useState();
  const [originalTableData, updateOriginalTableData] = useState([]);

  const deleteItem = id => async () => {
    updateLoading(true);
    const resp = await deletePreSettlement(id);
    updateLoading(false);

    if (resp !== undefined) {
      updateData(data.filter(item => item.id !== id));
      updateRequestId(null);
    }
  };

  const updateStatusRecords = async (ids, status) => {
    updateLoading(true);
    const requestType = 'SCHEDULED';
    const entities = ids.map(id => ({ id, requestType }));
    const response = await patchPreSettlement({ entities, approvalAction: status });

    if (response) {
      const updatedData = data.map((item) => {
        const itemIndex = response.findIndex(updated => updated.id === item.id);
        if (itemIndex > -1) {
          item.status = response[itemIndex].status;
        }

        return item;
      });
      updateData(updatedData);
      updateOriginalTableData(updatedData);
    }
    updateLoading(false);
  };

  useEffect(() => {
    const getAll = async () => {
      updateLoading(true);
      let response = await getPreSettlements();
      updateLoading(false);

      const params = new URLSearchParams(location.search);
      const id = params.get('requestId');

      if (response && response.length) {
        response = response.map(obj => ({
          ...obj,
          joinedMailClasses: obj.mailClass
            ? obj.mailClass.map(mailClass => mailClass.label).join(', ')
            : '',
          joinedImpcs: obj.impc ? obj.impc.map(impc => impc.label).join(', ')
            : '',
        }));
        updateRequestId(id || response[0].id);
        updateData(response);
        updateOriginalTableData(response);
      }

      const userPartyResponse = await authentication();

      if (userPartyResponse) {
        setUserPartyCode(userPartyResponse);
      }
    };

    getAll();
  }, []);

  return [data, requestId, updateRequestId, loading, deleteItem, updateStatusRecords, userPartyCode, updateData, originalTableData];
};
